/* eslint-disable */

interface CustomerInfo {
    info_type: number
    info_desc: string
    info_url: string
    fission: number
    merchant: number
}

const app = {

    state: {
        device: 'desktop',
        token: '',
        height: 100,
        infoType: 0,
        infoDesc: '',
        infoUrl: '',
        fission: 0,
        merchant: 0,
    },

    mutations: {

        toggleDevice(state: any, device: string) {
            state.device = device
        },
        setToken(state: any, token: string) {
            state.token = token
            console.log(state)
        },
        setHeight(state: any, height: number) {
            state.height = height
        },
        setInfo(state: any, info: CustomerInfo) {
            state.infoType = info.info_type
            state.infoDesc = info.info_desc
            state.infoUrl = info.info_url
            state.fission = info.fission
            state.merchant = info.merchant
        }
        ,
        setFission(state: any, fission: number) {
            state.fission = fission
        },
        setMerchant(state: any, merchant: number) {
            state.merchant = merchant
        },
    },

    actions: {
        toggleDevice(action: any, device: string) {
            action.commit('toggleDevice', device)
        },
        setToken(action: any, token: string) {
            action.commit('setToken', token)
        },
        setHeight(action: any, height: string) {
            action.commit('setHeight', height)
        },
        setInfo(action: any, info: CustomerInfo) {
            action.commit('setInfo', info)
        },
        setFission(action: any, fission: number) {
            action.commit('setFission', fission)
        },
        setMerchant(action: any, merchant: number) {
            action.commit('setMerchant', merchant)
        },
    }

}

export default app
